export enum GenesysTransferPanelSearchAvailability {
  AVAILABLE = 'available',
  AWAY = 'away',
  BUSY = 'busy',
  OFFLINE = 'offline'
}
